import { TOKEN_KEY } from "authProvider";
import axios, { isAxiosError } from "axios";
import { IProduct } from "types";

// A 400 response with this message is part of the product API contract.
// Other errors (especially 401/403/5xx) must not be labelled "inactive".
export type CartProductLookup =
  | { id: number; state: "active"; product: IProduct }
  | { id: number; state: "inactive"; name?: string }
  | { id: number; state: "error" };

export const fetchCartProduct = async (
  id: number,
  counterpartyId: number,
  outletId: number,
): Promise<CartProductLookup> => {
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    const response = await axios.get<IProduct>(
      `${process.env.REACT_APP_API_URL}/product/${id}`,
      {
        params: {
          c: counterpartyId,
          o: outletId,
        },
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    );
    const product = response.data;

    // Do not assume that a successful HTTP response guarantees a usable product.
    if (
      response.status !== 200 ||
      !product ||
      product.id !== id ||
      typeof product.isActual !== "boolean"
    ) {
      return { id, state: "error" };
    }
    if (!product.isActual) {
      return { id, state: "inactive", name: product.name || undefined };
    }
    return { id, state: "active", product };
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 400) {
      const message = error.response.data?.message;
      if (typeof message === "string" && /товар.*не\s*доступн/i.test(message)) {
        return { id, state: "inactive" };
      }
    }
    return { id, state: "error" };
  }
};
